import React, { PureComponent } from 'react';
import { Query } from "react-apollo"
import gql from "graphql-tag"

import getGraphqlURI from 'utils/getGraphqlURI'
import RefetchOnLocaleChange from 'utils/RefetchOnLocaleChange'

const prepareMenuItems = (edges) => {
  return edges.map(edge => {
    const node = { ...edge.node }
    if (node.childItems) {
      node.childItems = prepareMenuItems(node.childItems.edges)
    }
    return node
  })

}

export default (location, prop, getLocale = props => props.match.params.language) => WrappedComponent => class WithNav extends PureComponent {
  render() {
    const locale = getLocale(this.props)

    return (
      <Query
        context={{
          uri: getGraphqlURI(locale)
        }}
        variables={{ location }}
        query={gql`
          query menuItems${location}${locale}($location: MenuLocation!)
          {
            menuItems(where: { location: $location }) {
              edges {
                node {
                  id
                  label
                  url
                  childItems {
                    edges {
                      node {
                        id
                        label
                        url
                        icon
                      }
                    }
                  }
                }
              }
            }
          }`
        }
      >
        {({ loading, error, data, refetch }) => (
          <div>
            {!error &&
              <RefetchOnLocaleChange locale={locale} refetch={refetch}>
                <WrappedComponent
                  {...this.props}
                  {...{
                    [`${prop}Loading`]: loading,
                    [`${prop}`]: !loading && !error ? prepareMenuItems(data.menuItems.edges) : [],
                  }}
                />
              </RefetchOnLocaleChange>
            }
            {error && <h1>Error: {error.message}</h1>}
          </div>
        )}
      </Query>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/withNav.js